/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Button, InputGroup } from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";

// Moment

// Datepicker
import "react-datepicker/dist/react-datepicker.css";
// import pt from "date-fns/locale/pt";

const CustomInputNumber = ({
  register,
  id,
  className,
  defaultValue,
  step,
  onChange,
  isPercent,
  isFloat,
  t,
  tReady,
  ...inputProps
}) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <React.Fragment>
      <InputGroup>
        <div className="input-group-prepend">
          <Button
            type="button"
            color="primary"
            onMouseDown={() => {
              setValue(
                isFloat
                  ? parseFloat(parseFloat("0" + value) - step)
                  : parseInt(parseInt("0" + value) - step)
              );
              onChange &&
                onChange(
                  isFloat
                    ? parseFloat("0" + value) - step
                    : parseInt("0" + value) - step
                );
              document.getElementById(id).stepDown();
              document.getElementById(id).dispatchEvent(new Event("input"));
            }}
          >
            <i className="mdi mdi-minus"></i>
          </Button>
        </div>
        <input
          type="number"
          id={id}
          ref={register}
          className={className}
          step={step}
          onChange={(e) => {
            setValue(
              isFloat
                ? parseFloat("0" + e.target.value)
                : parseInt("0" + e.target.value)
            );
            onChange &&
              onChange(
                isFloat
                  ? parseFloat("0" + e.target.value)
                  : parseInt("0" + e.target.value)
              );
          }}
          defaultValue={defaultValue}
          {...inputProps}
        />
        <div className="input-group-append">
          {isPercent && <span className="input-group-text">%</span>}
          <Button
            type="button"
            color="primary"
            onMouseDown={() => {
              setValue(
                isFloat
                  ? parseFloat(parseFloat("0" + value) + step)
                  : parseInt(parseInt("0" + value) + step)
              );
              onChange &&
                onChange(
                  isFloat
                    ? parseFloat("0" + value) + step
                    : parseInt("0" + value) + step
                );
              document.getElementById(id).stepUp();
              document.getElementById(id).dispatchEvent(new Event("input"));
            }}
          >
            <i className="mdi mdi-plus"></i>
          </Button>
        </div>
      </InputGroup>
    </React.Fragment>
  );
};

export default withTranslation()(CustomInputNumber);
